import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { TextField } from "@mui/material";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputNumber = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  multiple,
}: IFormGenInputProps<Schema, T>) => {
  if (multiple) {
    throw new Error("Multiple number input is not supported yet");
  }

  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={undefined as unknown as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => (
        <TextField
          label={uiSchemaElement.label}
          type="number"
          value={field.value ?? ""}
          // The DOM input emits strings: convert back to a number so the AJV `type: number`
          // validation passes
          onChange={(event) => {
            const raw = event.target.value;
            if (raw === "") {
              field.onChange(undefined);
              return;
            }
            const value = Number(raw);
            if (value < 0) {
              return;
            }
            field.onChange(value);
          }}
          onKeyDown={(event) => {
            if (event.key === "-") {
              event.preventDefault();
            }
          }}
          onBlur={field.onBlur}
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
          inputRef={field.ref}
          size="small"
          fullWidth
          disabled={uiSchemaElement.disabled}
          slotProps={{ htmlInput: { min: 0 } }}
        />
      )}
    />
  );
};
